export default __webpack_public_path__ + "static/media/EditListIcon.b58a2085.svg";